// External
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// Internal
import { SharedModule } from 'src/app/common/components/shared.module';
import { UiAvatarModule } from 'src/app/common/components/ui/ui-avatar/ui-avatar.module';
import { UiCardModule } from 'src/app/common/components/ui/ui-card/ui-card.module';
import { UiDrawerModule } from 'src/app/common/components/ui/ui-drawer/ui-drawer.module';
import { UiDropdownModule } from '../common/components/ui/ui-dropdown/ui-dropdown.module';
import { UiToolbarModule } from 'src/app/common/components/ui/ui-toolbar/ui-toolbar.module';
import { HeaderComponent } from 'src/app/common/components/header/header.component';
import { UserDetailsComponent } from 'src/app/common/components/user-details-drawer/user-details.component';
import { DirectivesModule } from 'src/app/common/components/directives.module';
import { AppOrganiserComponent } from './app.organiser.component';
import { AppOrganiserRoutes } from './app.organiser.routes';
import { NotificationsComponent } from '../pages/notifications/notifications.component';
import { NotificationDetailsComponent } from '../pages/notifications/notification-details/notification-details.component';
import { EmptyStateModule } from '../common/components/empty-state/empty-state.module';
import { SideMenuComponent } from '../common/components/side-menu/side-menu.component';
import { UiIconModule } from '../common/components/ui/ui-icon/ui-icon.module';
import { UiAlertModule } from '../common/components/ui/ui-alert/ui-alert.module';
import { UiLoaderModule } from '../common/components/ui/ui-loader/ui-loader.module';
import { UiFormModule } from '../common/components/ui/ui-form/ui-form.module';
import { PipesModule } from '../common/pipes/pipes.module';
import { UiLogoModule } from '../common/components/ui/ui-logo/ui-logo.module';
import { UiTooltipModule } from '../common/components/ui/ui-tooltip/ui-tooltip.module';
import { UiTagModule } from '../common/components/ui/ui-tag/ui-tag.module';
import { ConnectionStatusModule } from '../common/components/connection-status/connection-status.module';
import { UiPopoverModule } from '../common/components/ui/ui-popover/ui-popover.module';

@NgModule({
    declarations: [
        AppOrganiserComponent,
        HeaderComponent,
        UserDetailsComponent,
        NotificationsComponent,
        NotificationDetailsComponent,
        SideMenuComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        RouterModule.forChild(AppOrganiserRoutes),
        DirectivesModule,
        EmptyStateModule,
        UiAvatarModule,
        UiCardModule,
        UiDrawerModule,
        UiToolbarModule,
        UiDropdownModule,
        UiIconModule,
        UiAlertModule,
        UiLoaderModule,
        UiFormModule,
        PipesModule,
        UiLogoModule,
        UiTooltipModule,
        UiTagModule,
        UiPopoverModule,
        ConnectionStatusModule
    ],
    providers: [],
    exports: [
        UiTooltipModule,
        UiIconModule
    ]
})

export class AppOrganiserModule {}
